import { t } from "@lingui/core/macro";
import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import {
  CreateDiningBookingHoldInput,
  useCreateReservationHoldMutation,
} from "./__generated__/useCreateReservationHoldMutation.graphql";

export const useCreateReservationHold = () => {
  const { showToast } = useToast();
  const [commitCreateReservationHold, isCreating] =
    useMutation<useCreateReservationHoldMutation>(
      useCreateReservationHoldMutationString
    );

  const createReservationHold = (
    input: CreateDiningBookingHoldInput,
    callback: (reservationHoldId: string | null) => void
  ) => {
    commitCreateReservationHold({
      variables: { input },
      onCompleted: (res) => {
        callback(res?.createDiningBookingHold?.reservationHoldId || null);
      },
      onError: (errors) => {
        showToast({
          description: t`Sorry. An error occurred while reserving your booking.`,
          semanticStyle: "error",
          toastId: "create-dining-hold-error",
        });
        callback(null);
      },
    });
  };

  return [createReservationHold, isCreating] as const;
};

export const useCreateReservationHoldMutationString = graphql`
  mutation useCreateReservationHoldMutation(
    $input: CreateDiningBookingHoldInput!
  ) {
    createDiningBookingHold(input: $input) {
      reservationHoldId
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
